import React from 'react';
import {connect} from 'react-redux';
import {Typography} from '@mui/material';

import {Dispatch} from 'spectra-logic-ui';
import {deleteResource} from 'spectra-logic-ui/actions';
import {FormDialog} from 'spectra-logic-ui/components';

import {Action, UserAction} from '@/types';
import {IAMUser} from '@/iam/types';

type Props = {
  user: IAMUser;
  userAction: UserAction;
  actions: Action[];
  onSubmit: (values: any) => Promise<any>;
  onSuccess: (...args: any) => any;
}

const RemoveActionDialog = ({user, userAction, actions, ...others}: Props) => {
  const action = actions.find((a) => a.id === userAction.id);
  let actionTitle = userAction.id;
  if (action) {
    actionTitle = action.title;
    if (action.version) {
      actionTitle += ` - Version ${action.version}`;
    }
  }
  return (
    <FormDialog title='Remove Action From IAM User' submitLabel='Remove' closeOnSuccess {...others}>
      {() => (
        <Typography>
          <strong>Remove '{actionTitle}' from '{user.username}'?</strong>
        </Typography>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, {user, userAction}: Props) => {
  const resource = `actions/${user.accountid}/${userAction.action}`;
  return {
    onSubmit: () => dispatch(deleteResource(resource, user.username, {})),
  };
};

export default connect(null, mapDispatchToProps)(RemoveActionDialog);
